import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Dialog } from '../dialog';
function Header(props) {
    return _jsx(Dialog.Header, Object.assign({}, props));
}
export default Header;
